import axios from 'src/utils/axios';

const v3_actionGetMessagesWithoutInteraction = (clienteId, params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.periodo) queryParams.append('periodo', params.periodo);
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);

    const queryString = queryParams.toString();
    return axios.get(`/v3/chats/health/${clienteId}/sem-interacao${queryString ? `?${queryString}` : ''}`);
};

export default v3_actionGetMessagesWithoutInteraction;
